<template>
  <div>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <v-sheet class="py-6 py-md-8 px-3" color="primary">
        <TitleWidget :small="xsOnly" dark> Estrutura </TitleWidget>
      </v-sheet>

      <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16">
        <template v-if="items.length">
          <template v-for="({ title, gallery, text }, keyItems) in items">
            <div :key="keyItems" :class="{ 'mt-10 mt-md-12': keyItems > 0 }">
              <TitleWidget :has-underline="false" small>
                {{ title }}
              </TitleWidget>
              <div v-html="text"></div>
              <GallerySection v-if="gallery.length > 1" :items="gallery" />
            </div>
          </template>
        </template>

        <v-alert v-else type="info">{{ noContentText }}</v-alert>
      </v-container>
    </template>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import GallerySection from "../components/sections/GallerySection.vue";

const _config = {
  mod: "school-galleries",
};

const _data = {
  loading: true,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ title, img, text }) => {
        const item = {
          title,
          text,
        };

        if (img?.list.length)
          item.gallery = img.list.map(({ path, title }) => ({
            src: this.files + path,
            caption: title,
          }));

        return item;
      });
    },
    title() {
      return "Estrutura";
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    item() {
      document.title = `${this.title} | ${this.name}`;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    TitleWidget,
    GallerySection,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  max-height: 60vh;
  max-width: 100%;
  object-fit: contain;
}
</style>
